<template>
  <div class="workOrder">
    <el-form :inline="true">
      <el-row>
        <el-form-item label="时间：">
          <el-date-picker
            v-model="date"
            value-format="yyyy-MM-dd"
            style="width: 428px"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目：">
          <el-select v-model="projectId" placeholder="请选择项目">
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="primary" @click="createWorkOrder">新建工单</el-button>
        <el-button type="primary" @click="exportExcel">导出全部工单信息表</el-button>
      </el-row>
    </el-form>

    
    <el-table :data="list" border style="width: 100%">
      <el-table-column type="index" label="序号" width="55px" align="center">
      </el-table-column>
      <el-table-column prop="projectName" label="项目名称" sortable> </el-table-column>
      <el-table-column prop="roadName" label="道路(小区)" sortable> </el-table-column>
      <el-table-column prop="type" label="工单类型" sortable> </el-table-column>
      <el-table-column prop="deadline" label="截止时间" sortable> </el-table-column>
      <el-table-column prop="description" label="工单名称" sortable> </el-table-column>
      <el-table-column prop="createTime" label="工单时间" sortable> </el-table-column>
      <el-table-column prop="managerName" label="项目负责人" sortable> </el-table-column>
      <el-table-column prop="status" label="任务情况" sortable>
        <template slot-scope="scope">
          <span>{{ scope.row.status | filterStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130px">
        <template slot-scope="scope">
          <el-button @click="goToRelease(scope.row)" type="text" style="margin-left: 10px;"
            >派发工单</el-button
          >
          <el-button @click="goToDetail(scope.row)" type="text"
            >工单详情</el-button
          >
          <el-button
            v-if="adminInfo"
            type="text"
            size="medium"
            @click="cancelFunc(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--    &lt;!&ndash;页码&ndash;&gt;-->
    <!--    <pagination-->
    <!--        v-show="total > 0"-->
    <!--        :total="total"-->
    <!--        :page.sync="query.current"-->
    <!--        :limit.sync="query.size"-->
           <!-- @pagination="getList" -->
    <!--    />-->
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span style="font-size: 18px; font-weight: 700">确定删除此工单？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ensureClick()">确 定</el-button>
      </span>
    </el-dialog>
  
    <!-- 新建工单弹窗 -->
    <el-dialog
      title="新建工单"
      :visible.sync="createOrderVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="handleCloseOrderDialog"
    >
      <create-new-order v-if="createOrderVisible" @close="createOrderVisible = false" @success="handleOrderSuccess"></create-new-order>
    </el-dialog>
  <!-- 派发工单弹窗 -->
    <el-dialog
      :visible.sync="releaseOrderVisible"
      :close-on-click-modal="false"
      @close="releaseOrderVisible = false"
      custom-class="release-order-dialog"
    >
      <NewTaskElement   v-if="releaseOrderVisible" :selectedRowId="selectedRowId" @close="releaseOrderVisible = false" @success="handleReleaseOrderSuccess"></NewTaskElement>
    </el-dialog>
    <!-- 隐藏的AllWorkOrder组件，用于导出功能 -->
    <AllWorkOrderTemplate ref="AllWorkOrderTemplate" style="display: none;"></AllWorkOrderTemplate>
    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import WorkOrderApi from '@/api/workOrder';
import TaskDispatchApi from '@/api/taskDispatch';
import CommonUtil from '@/utils/commonUtil';
import CreateNewOrder from './CreateNewOrder.vue';
import NewTaskElement from './NewTaskElement.vue';
export default {
  name: 'WorkOrder',
  components: {
    CreateNewOrder,
    NewTaskElement,
    AllWorkOrderTemplate: () => import('../exports/AllWorkOrderTemplate.vue'),
  },
  data() {
    return {
      dialogVisible: false,
      createOrderVisible: false,
      releaseOrderVisible: false,
      selectedRowId: null,
      adminInfo: null,
      projectNameList: [],
      projectId: '',
      projectList: [],
      list: [],
      total: 0,
      date: [],
      query: {
        current: 0,
        endTime: '',
        size: 10,
        startTime: '',
      },
      queryOne: {
        current: 0,
        size: 10,
        projectName: '',
        contractName: '',
      },
    };
  },
  mounted() {
    this.getList();
    this.getProjectList();
    this.getUserInfoName();
  },
  filters: {
    filterStatus(val) {
      if (val === 0) {
        return '待分配';
      } else if (val === 1) {
        return '进行中';
      } else if (val === 2) {
        return '已完成';
      } else if (val === 3) {
        return '已撤回';
      } else if (val === 4) {
        return '已作废';
      }
      return '';
    },
  },
  methods: {
    exportExcel() {
      // 直接调用AllWorkOrder组件的导出功能
      // this.$refs.allWorkOrder.exportToWord();
      this.$refs.AllWorkOrderTemplate.exportToWord();
    },
    cancelFunc(data) {
      this.dialogVisible = true;
      this.deleteId = data.id;
    },
    ensureClick() {
      TaskDispatchApi.taskDelete({ id: this.deleteId }).then((res) => {
        this.dialogVisible = false;
        this.getList();
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //身份校验
    getUserInfoName() {
      TaskDispatchApi.getUserInfo().then((res) => {
        if (res.data.code === 200) {
          this.adminInfo = res.data.data.sysAdmin;
        }
        console.log('-->>', this.adminInfo);
      });
    },
    getProjectList() {
      TaskDispatchApi.getProjectListPage(this.queryOne).then((res) => {
        if (res.data.code === 200) {
          // console.log('-->>', res);
          this.projectNameList = res.data.data.records;
          this.projectList = this.projectNameList.map((item) => ({
            projectId: item.projectId,
            projectName: item.projectName,
            value: item.projectId,
          }));
        }
      });
    },

    getList() {
      // console.log(this.query);
      if (this.date) {
        this.query.startTime = this.date[0];
        this.query.endTime = this.date[1];
        this.query.projectId = this.projectId;
      } else {
        this.query.startTime = '';
        this.query.endTime = '';
        this.query.projectId = this.projectId;
      }
      console.log(this.query);

      WorkOrderApi.queryPage(this.query).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.data.records;
          this.total = res.data.data.total;
          // this.projectList = this.list.map((item) => ({
          //   projectId: item.projectId,
          //   projectName: item.projectName,
          //   value: item.projectId,
          // }));
          console.log('852', res);
        }
      });
    },
    goToDetail(row) {
      this.$router.push('/workOrderDetail?id=' + row.id);
    },
    handleCurrentChange(val) {
      this.query.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.query.size = val;
      this.query.current = 0;
      this.getList();
    },
    createWorkOrder() {
      this.createOrderVisible = true;
    },
    handleCloseOrderDialog() {
      this.createOrderVisible = false;
    },
    handleOrderSuccess() {
      this.createOrderVisible = false;
      this.getList();
    },
    handleReleaseOrderSuccess() {
      this.releaseOrderVisible = false;
      this.getList();
    },
    goToRelease(row) {
      this.selectedRowId = row.id;
      this.releaseOrderVisible = true;
      console.log(row);
            // this.$refs.newTaskElement.handleSelectedRow(row.id);

    }
  },
};
</script>

<style lang="scss" scoped>
.workOrder {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<style lang="scss">
.release-order-dialog {
  margin-top: 5vh !important;
}
</style>
